import type { HistogramHighlight } from '@charts';
import { clientItems, projectItems, workItems } from '@/data/experience';

export const highlightKey = (ids: string[]) => ids.join('|');

// Every highlight group the landing can activate, known upfront so the chart
// prebuilds all layers and activating one stays a pure CSS toggle.
const groups = new Map<string, string[]>();
for (const item of [...workItems, ...clientItems, ...projectItems]) {
  groups.set(highlightKey(item.pulseIds), item.pulseIds);
}

export const pulseHighlights: HistogramHighlight[] = [...groups].map(
  ([key, ids]) => ({ key, ids })
);
